<script>
import CrudList from 'Support/components/crud/CrudList.vue';
import HolidaysRequest from 'Domain/holidays/HolidaysRequest';
import DataTableDateOnlyColumn from 'Support/components/data-table/DataTableColumns/DataTableDateOnlyColumn.vue';

export default {
  name: 'HolidaysCrudList',
  extends: CrudList,
  data() {
    return {
      headers: [
        {
          text: this.$t('app.holidays.dataTable.date'),
          value: 'data',
          component: DataTableDateOnlyColumn,
        },
        {
          text: this.$t('app.holidays.dataTable.description'),
          value: 'descricao',
        },
      ],
      editRoute: 'HolidaysForm',
      requestClass: HolidaysRequest,
    };
  },
};
</script>
